import { Button } from '@/components/ui/button';
import { Sparkles } from 'lucide-react';
import { useAssistantPanel } from '../../contexts/AssistantPanelContext';
import { useAuth } from '@/contexts/AuthContext';
import { isAiAssistantEnabled, useFeatures } from '@/contexts/FeaturesContext';

export function AssistantFloatingButton() {
  const { isOpen, toggleAssistant } = useAssistantPanel();
  const { isAuthenticated, user } = useAuth();
  const { isEnabled } = useFeatures();

  if (!isAuthenticated) return null;
  if (!isAiAssistantEnabled(user?.role, isEnabled)) return null;
  if (isOpen) return null;

  return (
    <Button
      onClick={toggleAssistant}
      variant="outline"
      size="icon"
      aria-label="Open AI assistant"
      data-agent-target="assistant-open-button"
      data-testid="assistant-floating-button"
      className="fixed bottom-6 left-6 h-14 w-14 rounded-full shadow-lg z-40 transition-all duration-300 hover:scale-110 bg-white/80 dark:bg-background/80 backdrop-blur-sm hover:bg-white dark:hover:bg-background"
    >
      <Sparkles className="h-6 w-6" />
    </Button>
  );
}
